module.exports = __webpack_public_path__ + "static/media/section_4_icon_1.79d64ad7.png";